import { useLang } from "@/i18n";
import { Phone } from "lucide-react";
import { trackCall } from "./PhoneHours";

export default function CallFloat() {
  const { t } = useLang();
  return (
    <a
      data-testid="call-float-button"
      href="tel:+393713142397"
      onClick={() => trackCall("call_float")}
      className="fixed bottom-5 left-5 z-50 flex items-center gap-2.5 bg-[#25D366] hover:bg-[#128C4B] text-white rounded-full pl-4 pr-5 py-3.5 shadow-[0_12px_40px_rgba(37,211,102,0.45)] transition-all duration-300 hover:-translate-y-0.5 group"
    >
      <span className="relative flex w-6 h-6 items-center justify-center">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
        <Phone size={16} className="relative" />
      </span>
      <span className="text-xs font-bold hidden sm:block">{t("wa.tooltip")}</span>
    </a>
  );
}
